/**
 * A report's status as a mark and a word (§12.6: never the colour alone). A status this build does
 * not know — one the platform added after the pin — is shown as its code, neutral, rather than as
 * a missing key (ADR 9058).
 */

import { StatusMark } from '../../primitives';

import { STATUS_LABEL_KEY, STATUS_MARK } from './words';

export function ReportStatus({ status }: { readonly status: string }): React.JSX.Element {
  if (Object.hasOwn(STATUS_LABEL_KEY, status)) {
    const known = status as keyof typeof STATUS_LABEL_KEY;
    return <StatusMark mark={STATUS_MARK[known]} labelKey={STATUS_LABEL_KEY[known]} />;
  }
  return <span className="text-ink-label font-semibold whitespace-nowrap" translate="no">{status}</span>;
}
